import {  Ref, Definition } from '../../../framework/infra'

export default class Contribution extends Ref {
    static definitions = {
        type: { ref: require('./ContributionType'), text: 'Contribution Type'},
        amount: { type: Definition.types.AMOUNT, text: 'Amount', refText: 'type.desc'}
    }
    static key = 'type'
}
